module.exports = __webpack_public_path__ + "assets/img/icon10-menu2.c2cd29ac.svg";